import {
    FormatAlignCenterRounded,
    FormatAlignJustifyRounded,
    FormatAlignLeftRounded,
    FormatAlignRightRounded,
} from '@mui/icons-material';
import { fontList } from '../../data';
import AttrLabel from '../Components/AttrLabel';
import AttrField from './AttrField';
import ButtonField from './ButtonField';
import ColorField from './ColorField';
import PixelField from './PixelField';
import SelectField from './SelectField';
import FormatButtons from './FormatButtons';
import InlineLabel from '../Components/InlineLabel';
import { useTranslation } from 'react-i18next';
import { elements } from '@elements';

function TypographyFields({ globalProperty }) {
    const { t } = useTranslation();
    const property = `globalStyles.${globalProperty}`;

    return (
        <>
            <AttrLabel>{t('Font Family')}</AttrLabel>
            <AttrField
                Component={SelectField}
                name="font-family"
                property={property}
                options={fontList}
                renderOptionStyle={option => ({
                    fontFamily: option.value,
                })}
            />
            <AttrLabel>{t('Font Size')}</AttrLabel>
            <AttrField
                Component={PixelField}
                name="font-size"
                property={property}
                fallback={
                    elements.html.node.globalStyles[globalProperty]['font-size']
                }
            />
            <AttrLabel>{t('Color')}</AttrLabel>
            <AttrField
                Component={ColorField}
                name="color"
                property={property}
                fallback={elements.html.node.globalStyles[globalProperty].color}
            />
            <AttrLabel>{t('Line Height')}</AttrLabel>
            <AttrField
                type="number"
                name="line-height"
                placeholder={t('Line Height')}
                property={property}
                step="0.1"
                fallback={
                    elements.html.node.globalStyles[globalProperty][
                        'line-height'
                    ]
                }
            />
            <AttrLabel>{t('Letter Spacing')}</AttrLabel>
            <AttrField
                Component={PixelField}
                name="letter-spacing"
                placeholder={t('Letter Spacing')}
                property={property}
                step="0.1"
            />
            <InlineLabel label={t('Alignment')}>
                <AttrField
                    Component={ButtonField}
                    name="text-align"
                    property={property}
                    exclusive
                    dir="ltr"
                    options={[
                        { label: <FormatAlignLeftRounded />, value: 'left' },
                        {
                            label: <FormatAlignCenterRounded />,
                            value: 'center',
                        },
                        { label: <FormatAlignRightRounded />, value: 'right' },
                        {
                            label: <FormatAlignJustifyRounded />,
                            value: 'justify',
                        },
                    ]}
                />
            </InlineLabel>
            <InlineLabel label={t('Font Style')}>
                <FormatButtons property={property} nameCase="kebab" />
            </InlineLabel>
        </>
    );
}

export default TypographyFields;
